import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  imageInput: {
    display: 'none',
  },
}));
